import React from 'react';
import { ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export const UrgencySection: React.FC = () => {
  return <section className="py-12 px-4 bg-white" data-id="element-306">
      <div className="container mx-auto max-w-4xl" data-id="element-307">
        <div className="bg-red-50 border-2 border-red-100 rounded-3xl p-8 md:p-12 text-center shadow-sm" data-id="element-308">
          <div className="flex justify-center mb-6" data-id="element-309">
            <ClockIcon className="w-16 h-16 text-red-500 animate-pulse" data-id="element-310" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-red-600 mb-4" data-id="element-311">
            ¡Atención! Esta oferta es por tiempo limitado
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-312">
            El precio especial con el 78% de descuento y los 4 bonus gratuitos
            desaparecerán cuando el contador llegue a cero.
          </p>
          <div className="flex justify-center" data-id="element-313">
            <CountdownTimer variant="red" data-id="element-314" />
          </div>
        </div>
      </div>
    </section>;
};